
import React, { useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './css/BisharatMain.css';

import GlobalStyle from './styles/globalStyles';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import MemberDetail from './components/Members/MemberDetail';
import MemberCreate from './components/Members/MemberCreate';
import MemberProfilePic from './components/Members/MemberProfilePic';
import MemberEdit from './components/Members/MemberEdit';
import ChildrenDetail from './components/Partners/ChildrenDetail';
import ChildCreate from './components/Partners/ChildCreate';
import NotificationCreate from './components/Notifications/NotificationCreate';
import GalleryCreateImg from './components/Gallery/GalleryCreateImg';
import AlbumManager from './components/Gallery/AlbumManager';
import DisabledUsers from './components/Users/DisabledUsers';
import CreateModerator from './components/Users/CreateModerator';

import Home from './pages/Home';
import Gallery from './pages/Gallery';
import FamilyMembers from './pages/FamilyMembers';
import FamilyHistory from './pages/FamilyHistory';
import FamilyTree from './pages/FamilyTree';
import AboutUs from './pages/AboutUs';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Notifications from './pages/Notifications';
import Activities from './pages/Activities';
import AdminBoard from './pages/AdminBoard'
import FamilyStats from './pages/FamilyStats';
import Users from './pages/Users';
import ContactUs from './pages/ContactUs';
import FamilyTreeInstruction from './pages/FamilyTreeInstruction';
import NotFoundPage from './pages/NotFoundPage';
import ActivateUser from './components/Users/ActivateUser';
import ActivateBishSMS from './components/Users/ActivateBishSMS';
import ModifyNumberSMSVerify from './components/Users/ModifyNumberSMSVerify';
import ActivationError from './components/Users/ActivationError';
import UserDetail from './components/Users/UserDetail';
import ActivityCreate from './components/Activities/ActivityCreate';
import Activity from './components/Activities/Activity';
import Notification from './components/Notifications/Notification';
import PermissionRequestUsers from './components/Users/PermissionRequestUsers';
import PhoneModify from './components/Users/PhoneModify';
import ChangePassForm from './components/Users/ChangePassForm';
import ResetUserOrPass from './components/Users/ResetUserOrPass';
import ResetPassword from './components/Users/ResetPassword';
import DonationSuccess from './pages/DonationSuccess';
import PartnerCreate from './components/Partners/PartnerCreate';
import PartnerEdit from './components/Partners/PartnerEdit';
import PartnerDetail from './components/Partners/PartnerDetail';

//Related to Translate-Languages
import { I18nProvider, LOCALES } from './languages';






function App() {
  const langStorage = localStorage.getItem("selectedLanguage") ? localStorage.getItem("selectedLanguage") : LOCALES.ARABIC
  const [locale, setLocale] = useState(langStorage);
  
  const changeLang = (lang) => {
    localStorage.setItem("selectedLanguage",lang);
    setLocale(lang);
  }

  return (
    <>

<div className="language-bar">
                        <button onClick={()=> changeLang(LOCALES.ARABIC)} className="btn-flag-small"> العربيّة</button>
                        <button onClick={()=> changeLang(LOCALES.ENGLISH)} className="btn-flag-small"> English</button>
                        <button onClick={()=> changeLang(LOCALES.HEBREW)} className="btn-flag-small"> עברית</button>
                        </div>


   <I18nProvider locale={locale}>
                                             
       <Router>
       <GlobalStyle/>
      <Navbar/>

      <Switch>
        <Route path='/' exact component={Home} />

        <Route path='/contact-us' exact component={ContactUs} />

        <Route path='/login' exact component={Login} />

        <Route path='/register' exact component={Register} />

        <Route path='/donationsuccess' exact component={DonationSuccess} />

        <Route path='/family-gallery' exact component={Gallery} />
        <Route path='/family-gallery/create' exact component={GalleryCreateImg} />
        <Route path='/family-gallery/gallery-management' exact component={AlbumManager} />


        <Route path='/family-members' exact component={FamilyMembers} />
        <Route path='/family-members/create' exact component={MemberCreate} />
        <Route path='/family-members/familystats' exact component={FamilyStats} />
        <Route path='/family-members/:id/childcreate' exact component={ChildCreate} />
        <Route path='/family-members/:id' exact component={MemberDetail} />
        <Route path='/family-members/:id/edit' exact component={MemberEdit} />
        <Route path='/family-members/profile/:id' exact component={MemberProfilePic} />
        <Route path='/family-members/:id/children' exact component={ChildrenDetail} />

        <Route path='/family-partners/createpartner/:id' exact component={PartnerCreate} />
        <Route path='/family-partners/:id' exact component={PartnerDetail} />
        <Route path='/family-partners/:id/edit' exact component={PartnerEdit} />



        <Route path='/family-history' exact component={FamilyHistory} />

        <Route path='/family-tree/:id' exact component={FamilyTree} />
        <Route path='/family-tree-instruction' exact component={FamilyTreeInstruction} />

        <Route path='/family-aboutus' exact component={AboutUs} />

        <Route path='/profile' exact component={Profile} />

        <Route path='/family-notification' exact component={Notifications} />
        <Route path='/family-notification/create' exact component={NotificationCreate} />
        <Route path='/family-notification/:id' exact component={Notification} />
        

        <Route path='/family-activities' exact component={Activities} />
        <Route path='/family-activities/create' exact component={ActivityCreate} />
        <Route path='/family-activities/:id' exact component={Activity} />
     

        <Route path='/adminboard' exact component={AdminBoard} />
        <Route path='/adminboard/users/' exact component={Users} />
        <Route path='/adminboard/users/:username' exact component={UserDetail} />
        <Route path='/adminboard/addmoderators/' exact component={CreateModerator} />
        <Route path='/adminboard/disabledusers/' exact component={DisabledUsers} />
        <Route path='/adminboard/permissionRequestUsers/' exact component={PermissionRequestUsers} />

        <Route path='/activate/:username/:token' exact component={ActivateUser} />
        <Route path='/activateSMS/:username' exact component={ActivateBishSMS} />
        <Route path='/ModifyNumberSMSVerify/:username/:newNumber' exact component={ModifyNumberSMSVerify} />
        <Route path='/activationerror' exact component={ActivationError} />

        <Route path='/users/resetusernameorpassword' exact component={ResetUserOrPass} />
        <Route path='/users/:username/modifyphone' exact component={PhoneModify} />
        
        <Route path='/users/:username/resetpassword/:token' exact component={ResetPassword} />
        <Route path='/users/:username/changepassword' exact component={ChangePassForm} />

        <Route component={NotFoundPage} />
        </Switch>
    </Router>
    <Footer/>
    </I18nProvider>
   </>
  );
}

export default App;
